import { AxisBottom, AxisScale } from "@visx/axis"

export type XAxisSubProps = {
  scale: AxisScale
  top: number
  x: number
  chartWidth: number
  isMultiText?: boolean
}

export default function XAxisSub({
  scale,
  top,
  x,
  chartWidth,
  isMultiText,
}: XAxisSubProps) {
  return (
    <AxisBottom
      top={top}
      scale={scale}
      tickStroke={"white"}
      tickLabelProps={() => ({
        fontSize: 11,
        textAnchor: "middle",
        fontWeight: 400,
      })}
    >
      {(props) => {
        const tickLabelSize = 11
        return (
          <g>
            {props.ticks.map((tick, i) => {
              const tickX = tick.to.x
              const tickY = tick.to.y + tickLabelSize

              const splitValue = tick.formattedValue?.split("-")

              return (
                <g key={`vx-tick-${tick.value}-${i}`}>
                  <text
                    transform={`translate(${tickX}, ${tickY})`}
                    textAnchor="middle"
                    style={{
                      fontSize: "11px",
                      fill: "#424245",
                      letterSpacing: "0.4px",
                    }}
                  >
                    <tspan dy="10" x={!!x ? chartWidth / x : 0}>
                      {splitValue?.[0]}
                    </tspan>
                    {isMultiText && (
                      <tspan dy="10.5" x={!!x ? chartWidth / x : 0}>
                        {splitValue?.[1]}
                      </tspan>
                    )}
                  </text>
                </g>
              )
            })}
          </g>
        )
      }}
    </AxisBottom>
  )
}
